<template>
  <div class="select-pay-way">
    <div class="select-pay-way-content">
      <ul class="payway-select-container">
        <li
          class="select-items select-items-wrapper"
          :active="
            payType.f_pay_type == selectedPaytpe.f_pay_type &&
            payType.pay_type == selectedPaytpe.pay_type
          "
          :class="{
            active:
              payType.f_pay_type == selectedPaytpe.f_pay_type &&
              payType.pay_type == selectedPaytpe.pay_type,
            hasOtherContent:
              isBank(payType.f_pay_type, payType.pay_type) ||
              hasQuickCard(
                payType.f_pay_type,
                payType.pay_type,
                payType.user_infos
              ) ||
              canSelectMoney(payType.f_pay_type, payType.pay_type) ||
              isCoinsPay(payType) ||
              isCreditCard(payType) ||
              showPaypalAgreement(payType)
          }"
          v-for="(payType, index) in foldPayTypes"
          v-if="!isJpPnsHide(payType.pay_type)"
          :key="index"
          @click="
            selectPayType(
              payType,
              payType.child ? payType.child.length : 0,
              payType.f_pay_type + index,
              true
            )
          "
        >
          <div
            class="active-ico iconfont icon-choose"
            :class="{
              active:
                payType.f_pay_type == selectedPaytpe.f_pay_type &&
                payType.pay_type == selectedPaytpe.pay_type
            }"
          ></div>
          <div
            class="pay-type-parent"
            :class="{
              hasOtherContent:
                isBank(payType.f_pay_type, payType.pay_type) ||
                hasQuickCard(
                  payType.f_pay_type,
                  payType.pay_type,
                  payType.user_infos
                ) ||
                canSelectMoney(payType.f_pay_type, payType.pay_type) ||
                isCoinsPay(payType) ||
                isCreditCard(payType) ||
                showPaypalAgreement(payType)
            }"
          >
            <div class="pay-way-ico-wrap">
              <img
                :src="
                  getCurPayWayIcon(
                    payType.f_pay_type,
                    payType.pay_type,
                    childChannel.child_id
                  )
                "
                class="pay-way-icon"
                alt="pay-way-ico"
              />
            </div>
            <div class="name-tag-box">
              <p
                class="channel-name-text"
                :class="{
                  active:
                    payType.f_pay_type == selectedPaytpe.f_pay_type &&
                    payType.pay_type == selectedPaytpe.pay_type
                }"
              >
                {{ channelNameText(payType, childChannel) }}
              </p>
              <div class="tag-box">
                <span
                  class="type-lasted"
                  v-if="
                    !isHideLastPayWayFunc &&
                    lastPayType &&
                    payType.f_pay_type == lastPayType.f_pay_type &&
                    payType.pay_type == lastPayType.pay_type &&
                    (payType.child ? !payType.child.length : true)
                  "
                  >{{ letter.lastSelectTag }}</span
                >
                <span
                  class="type-discount"
                  v-if="
                    isCustomPaytypeDiscount(payType) &&
                    payType.pay_type !== 'virtual_account' &&
                    !hidePaytypeDisountTag
                  "
                >
                  {{ letter.gainPlus }}
                  {{ getPaytypeDiscount(payType) }}
                </span>
                <span
                  class="type-discount"
                  v-else-if="
                    payType.price_list.length > 0 &&
                    payType.price_list[0].EXTRA_RATIO >= 0.01 &&
                    payType.pay_type !== 'virtual_account' &&
                    !hidePaytypeDisountTag
                  "
                >
                  {{ letter.gainPlus }}
                  {{ ~~(payType.price_list[0].EXTRA_RATIO * 100) }}%
                </span>
                <!-- 银行汇款渠道需要显示最高加码 -->
                <span
                  class="type-discount"
                  v-if="
                    payType.price_list.length > 0 &&
                    payType.price_list[0].EXTRA_RATIO >= 0.01 &&
                    payType.pay_type == 'virtual_account' &&
                    !hidePaytypeDisountTag
                  "
                >
                  {{ letter.gainMostPlus }}
                  {{ ~~(getMostPlus(payType.price_list) * 100) }}%
                </span>
                <span
                  v-if="isFuntapGame && payType.pay_type === 'funtap_9pay'"
                  class="type-discount"
                >
                  Hoàn 5%
                </span>
                <span
                  class="type-discount"
                  v-if="
                    payType.child &&
                    payType.child.length &&
                    childChannel &&
                    childChannel.child_id
                      ? +childChannel.coupon
                      : +payType.coupon
                  "
                >
                  {{ letter.couponCanUseQuan }}
                </span>
              </div>
            </div>
            <Icon
              class="paytype-more-icon"
              pointClass="j-toogle-child-payType"
              v-if="payType.child && payType.child.length"
              :class="{
                active:
                  payType.child &&
                  payType.child.length &&
                  payTypeSeemIdentify[payType.f_pay_type + index]
              }"
            ></Icon>
            <Payment
              v-if="
                canSelectMoney(payType.f_pay_type, payType.pay_type) && !isCoins
              "
              :languages="letter"
              :curPayType="curPayType"
              :curProduct="curProduct"
              :curPrice="curPrice"
              :pricesList="pricesList"
              @showError="showError"
              @selectPayMent="selectPayMent"
            ></Payment>
            <bank-pay
              v-if="
                isBank(payType.f_pay_type, payType.pay_type) &&
                isBank(selectedPaytpe.f_pay_type, selectedPaytpe.pay_type)
              "
              :isCoins="isCoins"
              :game-id="gameId"
              :role-id="roleId"
              :role-name="roleName"
              :languages="letter"
              :server-id="ourServerId"
              :cur-pay-type="curPayType"
              @showError="showError"
            ></bank-pay>
            <quick-pay-card
              v-if="
                hasQuickCard(
                  payType.f_pay_type,
                  payType.pay_type,
                  payType.user_infos
                )
              "
              :languages="letter"
              :cur-pay-type="curPayType"
              :card-infos="payType.user_infos"
              :cur-card="curCard"
              @selectCard="selectCard"
              @showError="showError"
              @deleteCurPayTypeCard="deleteCurPayTypeCard"
            ></quick-pay-card>
            <coins-payment
              v-if="isCoinsPay(payType)"
              :curLocationVal="curLocationVal"
              :curCoins="curCoins"
              :curPayType="curPayType"
              :discountTransMount="discountTransMount"
            ></coins-payment>
            <credit-card
              v-if="isCreditCard(payType)"
              :curLocationVal="curLocationVal"
              :discountTransMount="discountTransMount"
              :curCoins="curCoins"
              :isCoins="isCoins"
              :language="letter"
              :curPayType="curPayType"
            ></credit-card>
            <paypal-direct
              v-if="showPaypalAgreement(payType)"
              :language="letter"
            ></paypal-direct>
          </div>
        </li>
      </ul>
      <p
        class="fold j-click-more-channel"
        v-show="payTypes.length > 3 && fold"
        @click="changeFoldState"
      >
        <span class="icon"></span>
        {{ letter.voucherMoreWay }}
      </p>
      <p class="no-pay-way" v-if="foldPayTypes.length <= 0">
        {{ letter.noPayWay }}
      </p>
    </div>
    <PopupWindow
      @onCancel="jiamaPopup = false"
      @onConfirm="jiamaPopup = false"
      type="tips"
      textAlign="left"
      :title="' '"
      v-if="jiamaPopup"
      :languages="letter"
      :content="jiamaContent"
    ></PopupWindow>
  </div>
</template>

<script>
import VerticalToggle from '@utiles/vertical-toggle';
import { RES_HOST, PAYTYPE_ICON_URL } from '@utiles/officialStore';
import BankPay from '@components/officialWebStore/paytype/BankPayway.vue';
import QuickPayCard from '@components/officialWebStore/paytype/QuickPayCard.vue';
import Payment from '@components/officialWebStore/paytype/Payment.vue';
import BankPayment from '@components/officialWebStore/paytype/BankPayment.vue';
import PaypalDirect from '@components/officialWebStore/paytype/PaypalDirect.vue';
import CreditCard from '@components/officialWebStore/paytype/CreditCard.vue';

import { mapState, mapGetters } from 'vuex';
import CoinsPayment from './CoinsPayment.vue';
import { UPDATE_HIDE_SUBMIT } from '@store/officialWebStore/index';
import {
  GET_BALANCE_ONE_USER_DATA,
  getCurrencyByArea
} from '@store/officialWebStore/coins';
import { locationType, clickButton } from '@plugins/biPoint/_configWebstoreV2';
import { paytypeDiscount } from '@configs/officialWebStore/paytypeDiscount';
import globalConfig from '@utiles/officialStore/globalConfig';
import { isHideLastPayWay } from '@utiles/hideLastPayWay';
export default {
  props: [
    'allPayTypes',
    'curPayType',
    'isFuntapGame',
    'gameId',
    'lastPayType',
    'roleId',
    'roleName',
    'ourServerId',
    'curCard',
    'isReload',
    'curProduct',
    'pricesList',
    'curPrice',
    'curLocationVal',
    'curCoins',
    'isCoins',
    'discountTransMount'
  ],
  data() {
    return {
      ICON_URI: RES_HOST + 'commonImg/store/',
      selectedPaytpe: this.curPayType,
      jiamaPopup: false,
      childChannel: {},
      fold: false,
      hadClickFold: false,
      limitAllPayTypes: [],
      balancePayTypes: [], // 余额筛选
      payTypes: [],
      firstLoad: true,
      isAutoSelect: false
    };
  },
  watch: {
    curPayType() {
      this.selectedPaytpe = this.curPayType;
    },
    curLocationVal() {
      this.hadClickFold = false;
    },
    allPayTypes: {
      deep: true,
      immediate: true,
      async handler() {
        this.filterLimitAllPayTypes();
        await this.filterBalancePayTypes();
        this.filterPayTypes();
        this.autoSelectPaytype();
      }
    }
  },
  computed: {
    ...mapState({
      letter: state => state.letter,
      loginType: state => state.login.loginType,
      isWhite: state => state.white,
      isSecurity: state => state.security
    }),
    ...mapGetters(['isJpPlatform', 'getPointPayChannelName', 'getCoinsName']),
    foldPayTypes: {
      get: function () {
        if (this.fold) {
          if (this.payTypes.length <= 3) {
            return this.payTypes;
          }
          let newArr = [];
          for (let i = 0; i < 3; i++) {
            newArr.push(this.payTypes[i]);
          }
          return newArr;
        }
        return this.payTypes;
      },
      set: function (val) {
        this.foldPayTypes = val;
      }
    },
    payTypeSeemIdentify() {
      const payTypeSeemIdentify = {};
      for (let i = 0, length = this.limitAllPayTypes.length; i < length; i++) {
        payTypeSeemIdentify[this.limitAllPayTypes[i].f_pay_type + i] = false;
      }
      return payTypeSeemIdentify;
    },
    jiamaContent() {
      return this.letter.jiamaInfo.replace(/\n/g, '</br>');
    },
    hidePaytypeDisountTag() {
      return this.$store.getters.hidePaytypeDisountTag;
    },
    isJpPnsHide() {
      // 某两个特定域名，不分游戏，不用跳转,支付渠道是日本地区的时候，隐藏指定渠道
      // 20240821 除了pnsofficial.com和window.atob('MzdnYW1lcy5jb20=')域名,隐藏指定渠道
      const hideWay = [
        'JP-BANK_TRANSFER-PAYEASY',
        'JP-WALLET-LINEPAY',
        'JP-OTC'
      ];
      const showDomain = ['pnsofficial.com', window.atob('MzdnYW1lcy5jb20=')];
      return function (payType) {
        return (
          this.curLocationVal === 'JP' &&
          !showDomain.includes(globalConfig.getMainHost()) &&
          hideWay.includes(payType)
        );
      };
    },
    isHideLastPayWayFunc() {
      return isHideLastPayWay(this.gameId, this.curLocationVal);
    }
  },
  created() {
    // 没有渠道的话就不选了
    if (this.payTypes.length <= 0) {
      return;
    }
  },
  methods: {
    autoSelectPaytype() {
      if (this.firstLoad && this.payTypes.length > 0) {
        this.selectFirstPayType();
        this.firstLoad = false;
      }
      if (this.isReload && this.payTypes.length > 0) {
        this.selectFirstPayType();
        this.$emit('resetReload');
      }
    },
    filterLimitAllPayTypes() {
      /**
       * 当交易金额低于最低可用金额时，或高于最高可用金额时，该渠道隐藏
       * limit_bottom_money和limit_top_money不为0的时候才是有效
       * 只对全球平台处理非平台币商品处理
       */
      if (this.isJpPlatform || this.isCoins) {
        this.limitAllPayTypes = this.allPayTypes;
        return;
      }
      const newAllPayType = [];
      let curUserNeedPayMoney = '';
      // 单商品购买支付金额
      curUserNeedPayMoney = this.curPrice?.TRANS_AMOUNT;
      curUserNeedPayMoney = Number(curUserNeedPayMoney || 0);
      for (let i = 0, len = this.allPayTypes.length; i < len; i++) {
        let bottomPriceFormat = this.allPayTypes[i].limit_bottom_money || 0;
        let topPriceFormat = this.allPayTypes[i].limit_top_money || 0;
        bottomPriceFormat = Number(bottomPriceFormat);
        topPriceFormat = Number(topPriceFormat);
        if (
          (curUserNeedPayMoney < bottomPriceFormat &&
            bottomPriceFormat !== 0) ||
          (curUserNeedPayMoney > topPriceFormat && topPriceFormat !== 0)
        ) {
          continue;
        } else {
          newAllPayType.push(this.allPayTypes[i]);
        }
      }
      // 如果没有渠道则隐藏提单
      this.$store.commit(UPDATE_HIDE_SUBMIT, newAllPayType.length <= 0);
      this.limitAllPayTypes = newAllPayType;
    },
    // 判断是否平台币渠道
    checkIsBalancePaytype(payType) {
      const coinsPayName = this.isJpPlatform ? 'points_pay' : 'user_balance_pay';
      return (
        payType &&
        payType.f_pay_type === coinsPayName &&
        payType.pay_type === coinsPayName
      );
    },
    // 隐藏余额为0的平台币渠道
    async filterBalancePayTypes() {
      let balancePayTypes = [];
      let balanceItem = '';
      for (let i = 0, len = this.limitAllPayTypes.length; i < len; i++) {
        const payType = this.limitAllPayTypes[i];
        if (this.checkIsBalancePaytype(payType)) {
          const { res } = await this.$store.dispatch(
            GET_BALANCE_ONE_USER_DATA,
            this.curLocationVal
          );
          if (
            parseInt(res.result) === 1 &&
            Array.isArray(res.data.balanceList) &&
            res?.data?.balanceList.length >= 1
          ) {
            const curLocationCurrency = getCurrencyByArea(this.curLocationVal);
            balanceItem = res.data.balanceList.find(item => {
              return (
                item?.currency === curLocationCurrency && +item?.amount > 0
              );
            });
            if (balanceItem) {
              balancePayTypes.push(payType);
            }
          }
        } else {
          balancePayTypes.push(payType);
        }
      }
      this.balancePayTypes = balancePayTypes;
    },
    filterPayTypes() {
      let typs = [];
      for (let i = 0, len = this.balancePayTypes.length; i < len; i++) {
        if (this.balancePayTypes[i].price_list.length > 0) {
          this.balancePayTypes[i]._index = i;
          // 如果上次储值渠道，就置顶
          if (
            !isHideLastPayWay(this.gameId, this.curLocationVal) &&
            this.balancePayTypes[i].f_pay_type == this.lastPayType.f_pay_type &&
            this.balancePayTypes[i].pay_type == this.lastPayType.pay_type
          ) {
            typs.unshift(this.balancePayTypes[i]);
          } else {
            typs.push(this.balancePayTypes[i]);
          }
        }
      }
      /**
       * 由于监听了curPrice在计算属性中filterAllPayTypes被用到，选择渠道会更新curPrice重新触发filterAllPayTypes，
       * 需要用hadClickFold记录当前地区渠道是否被展开过,否则每次选完渠道都会折叠起渠道
       */
      if (this.hadClickFold) {
        // 如果当前地区渠道被展开过，则选择当前地区渠道后保持展开
        this.fold = false;
      } else {
        this.fold = typs.length > 3;
      }
      this.payTypes = typs;
    },
    channelNameText(payType, childChannel) {
      if (payType.f_pay_type === this.getPointPayChannelName) {
        return this.getCoinsName;
      }
      return payType.child &&
        payType.child.length &&
        childChannel &&
        childChannel.child_id
        ? childChannel.child_name
        : payType.name;
    },
    changeFoldState() {
      this.hadClickFold = true;
      this.fold = !this.fold;
      clickButton({
        btnName: 'more_channels',
        locationKey: locationType.paytypeSection
      });
    },
    selectPayMent(payment) {
      this.$emit('selectPayMent', payment);
    },

    selectPayType(payType, hasChildPayTyp, targetParentKey, isHandSelect) {
      this.selectedPaytpe = payType;
      if (hasChildPayTyp) {
        this.controlChildSeem(targetParentKey);
      } else {
        if (isHandSelect) {
          payType.isAutoSelect = false;
        } else {
          payType.isAutoSelect = this.isAutoSelect;
        }
        this.$emit('selectPayWay', payType);
        this.childChannel = {};
      }
    },
    controlChildSeem(targetParentKey) {
      for (let i = 0, length = this.limitAllPayTypes.length; i < length; i++) {
        this.limitAllPayTypes[i].f_pay_type + i !== targetParentKey &&
          (this.payTypeSeemIdentify[
            this.limitAllPayTypes[i].f_pay_type + i
          ] = false);
      }
      this.$set(
        this.payTypeSeemIdentify,
        targetParentKey,
        !this.payTypeSeemIdentify[targetParentKey]
      );
    },
    selectChildPayType(payType, childIndex, pindex, childPayType) {
      // 选了哪个子渠道
      payType['selectChildIndex'] = childIndex;
      payType.isAutoSelect = this.isAutoSelect;
      this.$emit('selectPayWay', payType);
      this.payTypeSeemIdentify[pindex] = false;
      this.$nextTick(() => {
        this.childChannel = childPayType;
      });
    },
    openJiamaPopup() {
      this.jiamaPopup = true;
    },
    getCurPayWayIcon(fpt, pt, cid) {
      // 特殊处理代币先用游戏ico，渠道名称：日本平台叫points_pay，全球平台叫user_balance_pay
      const channelName = this.isJpPlatform ? 'points_pay' : 'user_balance_pay';
      if (fpt === channelName && pt === channelName) {
        return `${PAYTYPE_ICON_URL}${fpt}/gameid_${this.gameId}_${pt}.png`;
      }
      return `${PAYTYPE_ICON_URL}${fpt}/${pt}${
        cid &&
        fpt == this.selectedPaytpe.f_pay_type &&
        pt == this.selectedPaytpe.pay_type
          ? `/${cid}`
          : ''
      }.png`;
    },
    isBank(fpt, pt) {
      return fpt == 'virtual_account' && pt == 'virtual_account';
    },
    isCoinsPay(payType) {
      // 代币消费：接口返回的的父渠道f_pay_type和子渠道pay_type在全球叫：user_balance_pay；在日本叫points_pay
      const coinsPayName = this.isJpPlatform
        ? 'points_pay'
        : 'user_balance_pay';
      return (
        payType &&
        payType.f_pay_type === coinsPayName &&
        payType.pay_type === coinsPayName &&
        payType.f_pay_type == this.selectedPaytpe.f_pay_type &&
        payType.pay_type == this.selectedPaytpe.pay_type
      );
    },
    isCreditCard(payType) {
      return (
        payType &&
        payType.f_pay_type === 'credit_card' &&
        payType.f_pay_type == this.selectedPaytpe.f_pay_type
      );
    },
    showError(err) {
      this.$emit('showError', err);
    },
    selectCard(card) {
      this.$emit('selectCard', card);
    },
    deleteCurPayTypeCard(keyValue) {
      this.$emit('deleteCurPayTypeCard', keyValue);
    },
    hasQuickCard(fpt, pt, userInfo) {
      return (
        fpt == this.selectedPaytpe.f_pay_type &&
        pt == this.selectedPaytpe.pay_type &&
        fpt != 'checkout' &&
        userInfo &&
        userInfo.length > 0
      );
    },
    showPaypalAgreement(paytype) {
      return (
        paytype &&
        paytype.f_pay_type === 'paypal_api' &&
        paytype.pay_type === 'paypal_agreement' &&
        paytype.f_pay_type == this.selectedPaytpe.f_pay_type &&
        paytype.pay_type == this.selectedPaytpe.pay_type &&
        +this.isWhite &&
        +this.isSecurity
      );
    },
    selectFirstPayType() {
      this.isAutoSelect = true;
      this.selectPayType(this.payTypes[0]);
    },
    getMostPlus(list) {
      let res = 0;
      list.map(item => {
        if (+item.EXTRA_RATIO > res) {
          res = +item.EXTRA_RATIO;
        }
      });
      return res;
    },
    canSelectMoney(fpt, pt) {
      // loginType = 2 | 3时是大R支付，可以选择任意金额储值
      return (
        fpt == this.selectedPaytpe?.f_pay_type &&
        pt == this.selectedPaytpe?.pay_type &&
        (this.curPayType?.fixed == 1 ||
          this?.loginType == 2 ||
          this?.loginType == 3)
      );
    },
    isCustomPaytypeDiscount(payType) {
      const gameCustomPaytypeDisount = paytypeDiscount[+this.gameId];
      if (!gameCustomPaytypeDisount) {
        return false;
      }
      const customPaytypeDisountItem = gameCustomPaytypeDisount.find(
        item =>
          item?.pay_type == payType?.pay_type &&
          item?.f_pay_type == payType?.f_pay_type
      );
      if (customPaytypeDisountItem) {
        return true;
      }
      return false;
    },
    getPaytypeDiscount(payType) {
      const paytypeDiscountList = paytypeDiscount[+this.gameId];
      if (!paytypeDiscountList) return '';
      const configItem = paytypeDiscountList.find(
        item =>
          item?.f_pay_type == payType?.f_pay_type &&
          item?.pay_type == payType?.pay_type
      );
      if (!configItem) return '';
      return configItem?.discount || '';
    }
  },
  components: {
    VerticalToggle,
    BankPay,
    QuickPayCard,
    Payment,
    BankPayment,
    CoinsPayment,
    CreditCard,
    PaypalDirect
  }
};
</script>

<style lang="scss" scoped>
@import '@assets/scss/officialWebStore/_dimen.scss';
.select-pay-way {
  display: block;
  margin: 0 auto 24px;
  width: 100%;
  border: 2px solid #dddddd;
  border-radius: 9px;
  background: #fff;
}

.type-lasted {
  display: inline-block;
  flex-shrink: 0;
  margin-right: 10px;
  padding: 0 10px;
  text-align: center;
  font-size: 20px;
  color: $btnBg;
  border-radius: 9px;
  height: 27px;
  line-height: 27px;
  border: 1px solid $btnBg;
}
.channel-name {
  display: inline-block;
  position: relative;
  min-height: 0 !important;
  word-break: break-word;
  &-text {
    position: relative;
    z-index: 2;
  }
  &-shade {
    display: block;
    position: absolute;
    left: 0;
    bottom: 0;
    z-index: 1;
    width: 203px;
    height: 13px;
    background: url($tmslgImg + 'name-shade.png') no-repeat top;
    background-size: cover;
  }
}
.fold {
  height: 73px;
  line-height: 73px;
  text-align: center;
  font-size: 22px;
  color: #666666;
  background: #fff;
  border-top: 2px solid #dddddd;
  cursor: pointer;
  border-bottom-left-radius: 9px;
  border-bottom-right-radius: 9px;
  .icon {
    display: inline-block;
    margin-right: 10px;
    background: url($tmslgImg + 'channel-more.png') no-repeat;
    width: 20px;
    height: 19px;
  }
}
.no-pay-way {
  margin: 20px 0;
  padding: 10px;
  text-align: left;
  font-size: 24px;
}

@media screen and (orientation: landscape) {
  .fold {
    font-size: 16px;
    height: 53px;
    line-height: 53px;
    .icon {
      width: 12px;
      height: 13px;
    }
  }
}
</style>
